export default "__VITE_ASSET__5Vp5t4YK__"